import mergeVariables from '../../fe-brary-internals/merge-variables';
import base from '../../base';
import palette from './colours/palette';
import tints from './colours/tints';
import typography from './typography';
export default mergeVariables(
// colours
tints, palette,
// typography
typography,
// globals
base.grid, base.layers, base.spacing,
// components
base.components.icons, base.components.messages, base.components.form, base.components.input, base.components.buttons, base.components.social)({});